import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { ReactNode, useContext, useEffect } from "react";
import { default as Context } from "src/contexts/auth/authContext";
import OnBoarding from "src/pages/Onboarding/Onboarding";
import { User } from "src/types/user";
import { PATH_AUTH } from "src/utils/paths";

// ----------------------------------------------------------------------

type Props = {
	children: ReactNode;
};

export default function AuthGuard({ children }: Props) {
	const { state } = useContext(Context);
	const navigate = useNavigate();
	const { data: user } = useQuery<User>({
		queryKey: ["user"]
	});

	const { isInitialized, isAuthenticated, token } = state;

	useEffect(() => {
		if (!isAuthenticated && isInitialized && (token == "" || token === null)) {
			navigate({ to: PATH_AUTH.login, replace: true });
		}
	}, [isAuthenticated]);

	if (user && !user?.onboarding_completed) {
		return <OnBoarding />;
	}

	return <>{children}</>;
}
